import { ApiBase, HttpMethod } from "../core/api-base";
import { z } from "zod";
import { GenerateExportBody } from "../api/generated/exports.zod";

type GenerateExportPayload = z.infer<typeof GenerateExportBody>;

/**
 * Exports API client (ISS-08-015). Contract: config/api/exports.yaml — ApiBase
 * validates the responses against the generated registry.
 */
export class ExportAsyncApi extends ApiBase {
    public async generate(entity: string, params: Record<string, string>): Promise<Response> {
        const payload: GenerateExportPayload = {
            format: params.format === "json" ? "json" : "xlsx",
            include_review_questions: params.include_review_questions === "1" ? 1 : 0,
        };
        if (params.board_id) {
            payload.board_id = params.board_id as GenerateExportPayload["board_id"];
        }
        if (params.user_status) {
            payload.user_status = params.user_status as GenerateExportPayload["user_status"];
        }
        if (params.product_status) {
            payload.product_status = params.product_status as GenerateExportPayload["product_status"];
        }

        return super.apiRequest(
            `/api/v1/exports/${encodeURIComponent(entity)}/generate`,
            HttpMethod.Post,
            payload,
        );
    }

    public async status(entity: string): Promise<Response> {
        return super.apiRequest(`/api/v1/exports/${encodeURIComponent(entity)}/status`, HttpMethod.Get, null, {
            noSpinner: true,
        });
    }
}
